/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApp } from 'vue';
import { initIndexedDB } from '@/utils/indexedDB';
import { setDynamicRoutes } from '@/permission';
import App from './App.vue';
import router from './router';
import store from './store';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import './iconfont/font.css';
import './iconfont/iconfont.css';
import './global.scss';
import './antd.scss';
import './utils/zoom';
import './assets/css/style.css';

// 🔥 初始化：自动检测并创建两张表
initIndexedDB()
  .then(() => {
    console.log('✅ IndexedDB 初始化完成（表已确保存在）');
    router.beforeEach((to, from, next) => {
      let text = '';
      const sessionStr = sessionStorage.getItem('outer_order_record')
      if (sessionStr && to.path.includes('/throwInManage/outerOrder/')) text = JSON.parse(sessionStr).customerName;
      if (to.meta && typeof to.meta.title === 'string' && text) document.title = `${to.meta.title}（${text}）`;
      else if (to.meta && typeof to.meta.title === 'string') document.title = to.meta.title;
      else document.title = '默认标题';
      setDynamicRoutes();
      next();
    });

    const app = createApp(App);
    // 自定义 v-has 指令
    app.directive('has', {
      mounted(el, binding) {
        const page_key = el.getAttribute('page-key');
        const str = localStorage.getItem('user_info');
        if (str) {
          const userInfo = JSON.parse(str);
          let ids = [1, 2, 3, 18];
          if (page_key == 'supplier') ids = [1, 2, 3, 133, 134, 135];
          if (ids.includes(userInfo.id)) {
            console.log('允许操作！');
          } else if (binding.value !== userInfo.id) {
            el.parentNode && el.parentNode.removeChild(el);
          }
        }
      }
    });
    app.use(store).use(router).use(Antd).mount('#app');
  })
  .catch((err) => {
    console.error('❌ IndexedDB 初始化失败', err);
    router.beforeEach((to, from, next) => {
      // 检查to.meta.title是否存在
      if (to.meta && typeof to.meta.title === 'string') document.title = to.meta.title
      else document.title = '默认标题'
      setDynamicRoutes();
      next();
    });
    const app = createApp(App);
    // 自定义 v-has 指令
    app.directive('has', {
      mounted(el, binding) {
        const page_key = el.getAttribute('page-key');
        const str = localStorage.getItem('user_info');
        if (str) {
          const userInfo = JSON.parse(str);
          let ids = [1, 2, 3, 18];
          if (page_key == 'supplier') ids = [1, 2, 3, 133, 134, 135];
          if (ids.includes(userInfo.id)) {
            console.log('允许操作！');
          } else if (binding.value !== userInfo.id) {
            el.parentNode && el.parentNode.removeChild(el);
          }
        }
      }
    });
    app.use(store).use(router).use(Antd).mount('#app');
  });

